import request from '../utils/request'

export function getUserProduct(){
  return request({
    url: `/users/getUserWfProduct`,
    method: 'get',
  })
}

export function getDictionary(code){
  return request({
    url: `/dictionary/list/${code}`,
    method: 'get',
  })
}

export function creatTrade({type, ...params}){
  return request({
    url: `/trade/creatTrade/${type}`,
    method: 'post',
    data: params
  })
}

export function getTradeById({ tradeId }){
  return request({
    url: `/trade/getTradeById/${tradeId}`,
    method: 'get',
  })
}

export function creatPayTrade(params){
  return request({
    url: `trade/creatPayTrade`,
    method: 'post',
    data: params
  })
}



export function verifycode({tradeId}) {
  return request({
    url: `/trade/verifycode/${tradeId}`,
    method: 'get',
  })
}


export function creaTmallChpaTrade(params) {
  return request({
    url: `/trade/useTrade`,
    method: 'post',
    data: params
  })
}

export function getQRcodeBlob(){
  return request({
    url: `/users/getQrCode`,
    method: 'get',
    responseType: 'blob',
  })
}
// 兑换优惠券
export function redeemCoupon(params) {
  return request({
    url: `/coupon/redeemCoupon`,
    method: 'post',
    data: params
  })
}



